<template>
  <div>
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 主要内容区 - 会员中心左右结构 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="invoices" />
      <main class="flex-1 p-6">
        <div>
          <div class="mb-8">
            <h1 class="text-2xl font-bold text-gray-900">添加发票信息</h1>
            <p class="text-gray-600 mt-1">
              填写以下信息，提交后将生成新的发票记录
            </p>
          </div>

          <!-- 表单容器 -->
          <div
            class="bg-white rounded-xl shadow-sm border border-gray-100 pt-12 pr-12 pb-12 mb-6"
          >
            <el-form
              ref="invoiceForm"
              :model="invoiceData"
              :rules="rules"
              label-width="120px"
              class="invoice-form"
            >
              <el-form-item label="订单编号" prop="order_number">
                <el-input
                  v-model="invoiceData.order_number"
                  placeholder="请输入订单编号"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="发票类型" prop="invoice_type">
                <el-select
                  v-model="invoiceData.invoice_type"
                  placeholder="请选择发票类型"
                >
                  <el-option label="增值税普通发票" value="增值税普通发票"></el-option>
                  <el-option label="增值税专用发票" value="增值税专用发票"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="公司名称" prop="invoice_company">
                <el-input
                  v-model="invoiceData.invoice_company"
                  placeholder="请输入公司名称"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="税号" prop="invoice_tax">
                <el-input
                  v-model="invoiceData.invoice_tax"
                  placeholder="请输入纳税人识别号"
                  clearable
                ></el-input>
              </el-form-item>

               <el-form-item label="邮箱" prop="invoice_email">
                <el-input
                  v-model="invoiceData.invoice_email"
                  placeholder="请输入接收发票的邮箱"
                  type="email"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="注册地址">
                <el-input
                  v-model="invoiceData.invoice_address"
                  placeholder="请输入公司注册地址（非必填）"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="联系电话">
                <el-input
                  v-model="invoiceData.invoice_tel"
                  placeholder="请输入联系电话（非必填）"
                  clearable
                ></el-input>
              </el-form-item>



              <el-form-item>
                <div class="flex justify-end space-x-4">
                  <el-button @click="resetForm('invoiceForm')">取消</el-button>
                  <el-button type="primary" @click="submitForm('invoiceForm')"
                    >提交</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>

          <!-- 表单说明 -->
          <div
            class="text-sm text-gray-500 bg-white rounded-xl shadow-sm border border-gray-100 p-6"
          >
            <h4 class="font-medium text-gray-700 mb-3">发票说明：</h4>
            <ul class="space-y-2">
              <li class="flex items-start">
                <i class="ri-check-circle-line text-green-500 mr-2 mt-0.5"></i>
                <span>请确保填写的发票信息真实有效</span>
              </li>
              <li class="flex items-start">
                <i class="ri-check-circle-line text-green-500 mr-2 mt-0.5"></i>
                <span>增值税专用发票需要提供完整的地址和电话信息</span>
              </li>
              <li class="flex items-start">
                <i class="ri-check-circle-line text-green-500 mr-2 mt-0.5"></i>
                <span>电子发票将发送至您填写的邮箱</span>
              </li>
              <li class="flex items-start">
                <i class="ri-check-circle-line text-green-500 mr-2 mt-0.5"></i>
                <span>如有疑问，请联系客服</span>
              </li>
            </ul>
          </div>
        </div>
      </main>
    </div>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import LeftNav from "@/components/LeftNav.vue";
import api from "@/utils/api";

export default {
  name: "InvoiceAdd",
  components: {
    Nav,
    Footer,
    LeftNav,
  },
  data() {
    return {
      // 发票数据
      invoiceData: {
        order_number: "",
        invoice_type: "",
        invoice_company: "",
        invoice_tax: "",
        invoice_address: "",
        invoice_tel: "",
        invoice_email: "",
      },
      // 表单验证规则
      rules: {
        order_number: [
          { required: true, message: "请输入订单编号", trigger: "blur" },
        ],
        invoice_type: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        invoice_company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        invoice_tax: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          {
            pattern:
              /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
            message: "纳税人识别号格式不正确",
            trigger: "blur",
          },
        ],
        invoice_email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addInvoice();
        } else {
          this.$message.warning("请完整填写表单信息");
          return false;
        }
      });
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 调用API添加发票
    async addInvoice() {
      try {
        const response = await api.invoice.addInvoice(this.invoiceData);
        if (response.code === 200) {
          // 重置表单
          this.resetForm("invoiceForm");
          // 可以选择跳转到发票列表页或其他页面
          this.$router.push('/ucenter/invoices');
        }
      } catch (error) {
        console.error("添加发票失败:", error);
        this.$message.error("网络错误，请稍后重试");
      }
    },

    // 格式化当前日期
    formatDate(date, format = "YYYY-MM-DD") {
      return this.$tool.formatDate(date, format);
    },
  },
  mounted() {
    // 可以在这里进行一些初始化操作
    // 例如，如果从URL参数获取订单编号等
    if (this.$route.params.orderNumber) {
      this.invoiceData.order_number = this.$route.params.orderNumber;
    }
  },
};
</script>

<style scoped>
/* 表单样式 */
.invoice-form {
  width: 100%;
}

/* 按钮样式 */
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__label {
  font-weight: 500;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-form {
    label-width: 100px;
  }

  .grid-cols-2 {
    grid-template-columns: 1fr;
  }

  .flex {
    flex-direction: column;
  }

  main {
    padding: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/InvoiceAdd.vue